export const getOrderCoupons = ({ orderCoupon = {} } = {}) => orderCoupon;

export default getOrderCoupons;
